import React from 'react'
import SelectionCard from '../../../../../../components/WizardModal/SelectionCard'

const LOCATIONS = [
  { key: 'kitchen',          icon: '🍳', title: 'Kitchen' },
  { key: 'bathroom',         icon: '🚿', title: 'Bathroom' },
  { key: 'toilet',           icon: '🚽', title: 'Toilet' },
  { key: 'office_space',     icon: '🏢', title: 'Office Space' },
  { key: 'meeting_room',     icon: '🪑', title: 'Meeting Room' },
  { key: 'hallway',          icon: '🚪', title: 'Hallway / Corridor' },
  { key: 'storage_room',     icon: '📦', title: 'Storage Room' },
  { key: 'entrance',         icon: '🏛️', title: 'Entrance / Lobby' },
]

interface LocationStepProps {
  value: string
  onChange: (value: string) => void
}

const LocationStep = ({ value, onChange }: LocationStepProps) => (
  <div>
    <h3 style={{ fontSize: '1.125rem', fontWeight: 700, color: '#0a0d47', margin: '0 0 4px' }}>Where is the issue?</h3>
    <p style={{ fontSize: '0.875rem', color: '#9ca3af', margin: '0 0 24px' }}>Select the room or area affected.</p>
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '12px' }}>
      {LOCATIONS.map((loc) => (
        <SelectionCard
          key={loc.key}
          icon={<span style={{ fontSize: '28px', lineHeight: 1 }}>{loc.icon}</span>}
          title={loc.title}
          selected={value === loc.key}
          onClick={() => onChange(loc.key)}
        />
      ))}
    </div>
  </div>
)

export default LocationStep
